module.exports = __webpack_public_path__ + "static/img/company-frame.dac90e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate/company-frame.png
// module id = Eyk2
// module chunks = 1